import React from "react";

export default function LongBatteryIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    fill="#231F20"
                    d="M34 66C16.355 66 2 51.645 2 34S16.355 2 34 2s32 14.355 32 32c0 7.551-2.635 14.495-7.026 19.974l1.434 1.434C65.152 49.563 68 42.115 68 34 68 15.222 52.777 0 34 0S0 15.222 0 34s15.223 34 34 34c7.152 0 13.784-2.213 19.261-5.985l-1.141-1.659C46.964 63.912 40.723 66 34 66"
                    transform="translate(-1237 -2418) translate(1138 2398) translate(82 20) translate(17) translate(6 6)"
                  />
                  <path
                    fill="#231F20"
                    d="M57 46.315L58.573 56.191 68.449 54.617 68.134 52.642 60.234 53.901 58.976 46.001z"
                    transform="translate(-1237 -2418) translate(1138 2398) translate(82 20) translate(17) translate(6 6)"
                  />
                  <path
                    fill="#020303"
                    d="M32 50V39h-4l8-15v11h4l-8 15zm9.34-32H38v-4h-8v4h-3.34C25.2 18 24 19.2 24 20.66v30.66C24 52.8 25.2 54 26.66 54h14.66C42.8 54 44 52.8 44 51.34V20.66C44 19.2 42.8 18 41.34 18z"
                    transform="translate(-1237 -2418) translate(1138 2398) translate(82 20) translate(17) translate(6 6)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
